module.exports = __webpack_public_path__ + "img/category-sport.40b8ca12.png";